import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { RouterProvider } from 'react-router-dom'
import router from './router/router.jsx'
import { SocketProvider } from './pages/dashboard/telemedicine/context/SocketContext.jsx'
import AgoraRTC, { AgoraRTCProvider } from "agora-rtc-react";
import { ThemeProvider } from './context/ThemeContext.jsx'
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://6c2cd62b9775ee46d62e55b251b2aefc@o4508728473812992.ingest.us.sentry.io/4508728475910144",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/users.careapps\.net\/clinics/
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider>
      <AgoraRTCProvider client={client}>
        <SocketProvider>
          <RouterProvider router={router} />
        </SocketProvider>
      </AgoraRTCProvider>
    </ThemeProvider>
  </React.StrictMode>,
)
